import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Frame from './components/frame';
import { useState ,useEffect} from 'react';
import { BrowserRouter } from 'react-router-dom';
 
function Game() {

	useEffect(()=>{
		document.title="Wheel Of Fortune"
	})
	localStorage.setItem('moneyA', "0");
    localStorage.setItem('moneyB', "0");
    localStorage.setItem('moneyC', "0");

	localStorage.setItem('bankA', "0");
    localStorage.setItem('bankB', "0");
    localStorage.setItem('bankC', "0");

	localStorage.setItem('isWheelLocked', "1");


	// localStorage.setItem('puzzle1', "better to arrive late than not to come at all");
	// localStorage.setItem('puzzle2', "bite the bullet");
	// localStorage.setItem('puzzle3', "it is raining cats and dogs");
	// localStorage.setItem('puzzle4', "you only live once");
	// localStorage.setItem('puzzle5', "better safe than sorry");
	// localStorage.setItem('puzzle6', "your guess is as good as mine");
	// localStorage.setItem('puzzle7', "birds of a feather flock together");
	// localStorage.setItem('puzzle8', "bite off more than you can chew");
	// localStorage.setItem('puzzle9', "by the skin of your teeth");

	const [beginGame, setBeginGame] = useState(false);
	const [displayStartButton, setDisplayStartButton] = useState(false);
	const [showForm, setShowForm] = useState(true);
	const [playerA , setPlayerA] = useState('player 1');
	const [playerB , setPlayerB] = useState('player 2');
	const [playerC , setPlayerC] = useState('player 3');
	const puzzles = ["The hills have eyes","Fast and Furious","Birds in your hand better that ten on the tree","better to arrive late than not to come at all", "bite the bullet","it is raining cats and dogs",
	"you only live once", "better safe than sorry","your guess is as good as mine",
	"birds of a feather flock together","bite off more than you can chew","by the skin of your teeth"];
	
	const puzzlesCount = puzzles.length;
	const submitForm = e =>{

		e.preventDefault();
		if(e.target.p1.value.length >= 1 
			&& e.target.p1.value.replaceAll(' ', '').length > 0 
			&& /^[a-zA-Z]*$/.test(e.target.p1.value)){
			setPlayerA(e.target.p1.value);
		}

		if(e.target.p2.value.length >= 1 
			&& e.target.p2.value.replaceAll(' ', '').length > 0 
			&& /^[a-zA-Z]*$/.test(e.target.p2.value)){
			setPlayerB(e.target.p2.value);
		}

		if(e.target.p3.value.length >= 1 
			&& e.target.p3.value.replaceAll(' ', '').length > 0 
			&& /^[a-zA-Z]*$/.test(e.target.p3.value)){
			setPlayerC(e.target.p3.value);
		}

		setShowForm(false)
		setDisplayStartButton(true)
	}

	const startButtonClick = ()=>{
		setBeginGame(true)
		setDisplayStartButton(false)
	}

	const puzzleID = Math.floor(Math.random() * ((puzzlesCount-1) - 0) + 0)
	// i agree
	// self.resizeTo(width,height);

	// var myAudio = new Audio('src/components/data/wheeloffortunetheme.mp3'); 
	// 	myAudio.addEventListener('ended', function() {
	// 		this.currentTime = 0;
	// 		this.play();
	// 	}, false);
	// 	myAudio.play();
	  
	return  (
		
		// <Wheeling/>
		
		
		<div id="btnDiv" >

			{showForm && <form id='form' onSubmit={submitForm} style={{visibility: showForm}}>
				&nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;Enter players names
				<br></br><br></br>
				Player 1: &nbsp;&nbsp;
					<input id='p1' maxLength={10} placeholder="e.g Ali" />
					<br></br>
					Player 2: &nbsp;&nbsp;
					<input id='p2' maxLength={10} placeholder="e.g John" />
					<br></br>
					Player 3: &nbsp;&nbsp;
					<input id='p3' maxLength={10} placeholder="e.g Mary" />
					<br></br>
					<br></br>
					<input type={'submit'} style={{float: 'right'}}></input>
			</form>}		 
			{displayStartButton && <button id='btn' onClick= {startButtonClick}>	
				<h1 id="beginTxt">Start</h1>
			</button>}			
			{/* {beginGame && <Frame playerA = {playerA} playerB = {playerB} playerC = {playerC} />} */}
			{beginGame && <Frame whatRound={1} mwa={"0"} mwb = {"0"} mwc = {"0"} playerA = {playerA} playerB = {playerB} playerC = {playerC} pID={puzzleID}/>}
		</div>
	  )
	}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<BrowserRouter>
<Game />
</BrowserRouter>);

// i think i was just tring once it is not used anywhere 
// there is something if you noticed
// it updated to round four before it reloaded the page for a second
// it is not i agree
// did we forget anything 
// yep docs are next week

